export interface ProjectDependencyStackDepth {
  maxDepth: number;
  sfdcProjectId: string;
}
